export function handleError(error: any): void {
  if (error.code === 209) {
    localStorage.clear()
    return
  }
  console.log(error)
}
